import React from 'react';

import styled, { css } from 'styled-components/macro';
import {
    PRIMARY_500,
    GREY_700,
    GREY_100,
    PRIMARY_700,
    GREY_200,
    PRIMARY_600,
    YELLOW_500,
    GREY_000
} from './styles/colors';

import { Router, Link } from '@reach/router';
import { ancestries, ancestryIds } from './data/ancestry';
import {
    PRIMARY_BOLD_36,
    PRIMARY_BOLD_30,
    SECONDARY_18,
    PRIMARY_BOLD_24
} from './styles/fonts';

function UnitCard({ unit }) {
    const {
        name,
        description,
        race,
        equipment,
        experience,
        type,
        attack,
        defence,
        power,
        toughness,
        morale,
        size,
        cost
    } = unit;

    const qualifier = `${race} ${equipment} ${experience} ${type}`;

    return (
        <div css={cardWrapperStyles}>
            <div css={titleStyles}>{name}</div>
            <div>{qualifier}</div>
            <div css={descriptionStyles}>{description}</div>
            <div css={tableWrapper}>
                <table css={tableStyles}>
                    <tbody>
                        <tr css={rowStyles}>
                            <td css={trStyles}>
                                <div css={entryStyles}>
                                    <span>Attack:</span>
                                    <span>{attack}</span>
                                </div>
                            </td>
                            <td css={trStyles}>
                                <div css={entryStyles}>
                                    <span>Defence:</span>
                                    <span>{defence}</span>
                                </div>
                            </td>
                        </tr>
                        <tr css={rowStyles}>
                            <td css={trStyles}>
                                <div css={entryStyles}>
                                    <span>Power:</span>
                                    <span>{power}</span>
                                </div>
                            </td>
                            <td css={trStyles}>
                                <div css={entryStyles}>
                                    <span>Toughness:</span>
                                    <span>{toughness}</span>
                                </div>
                            </td>
                        </tr>
                        <tr css={rowStyles}>
                            <td css={trStyles}>
                                <div css={entryStyles}>
                                    <span>Morale:</span>
                                    <span>{morale}</span>
                                </div>
                            </td>
                            <td css={trStyles}>
                                <div css={entryStyles}>
                                    <span>Size:</span>
                                    <span>{size}</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>Cost: {cost} GP</div>
        </div>
    );
}
const cardWrapperStyles = css`
    display: inline-block;
    border: 2px solid black;
    padding: 1rem;

    width: 100%;
    max-width: 350px;
    text-align: center;
`;
const titleStyles = css``;
const descriptionStyles = css``;
const tableWrapper = css`
    margin: 0 1rem;
`;
const tableStyles = css`
    text-align: left;
    width: 100%;
    border-spacing: 0;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
`;
const rowStyles = css`
    border-top: 2px solid black;
`;
const trStyles = css`
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    padding: 0.25rem 0;
`;
const entryStyles = css`
    display: flex;
    justify-content: space-between;
    padding: 0 1rem;
`;

function Army({ army = [] }) {
    return (
        <div css={armyStyles}>
            {army.map(unit => (
                <UnitCard unit={unit} />
            ))}
        </div>
    );
}
const armyStyles = css`
    padding: 0.25rem;

    & > * {
        margin: 0.25rem;
    }
`;

const mockUnit = {
    name: 'My Unit',
    description: `At beatae quod architecto quae veritatis enim, dicta et consequatur obcaecati, modi labore id deleniti.`,
    race: 'Human',
    equipment: 'Medium',
    experience: 'Veteran',
    type: 'Infantry',
    attack: '+1',
    defence: '10',
    power: '+1',
    toughness: '10',
    morale: '+1',
    size: '1d6',
    cost: '30'
};
const army = Array.from(Array(8).keys()).map(() => mockUnit);

function Header() {
    return (
        <header
            css={css`
                border-top: 6px solid ${PRIMARY_500};
                background-color: white;
                box-shadow: 0px 1px 5px ${GREY_200};
            `}
        >
            <div
                css={css`
                    max-width: 1280px;
                    margin-left: auto;
                    margin-right: auto;
                `}
            >
                <Link css={linkStyles} to="/">
                    Home
                </Link>
                <Link css={linkStyles} to="/armies">
                    Armies
                </Link>
                <Link css={linkStyles} to="/data">
                    Data
                </Link>
                <Link css={linkStyles} to="/about">
                    About
                </Link>
            </div>
        </header>
    );
}
const linkStyles = css`
    color: ${GREY_700};
    text-decoration: none;
    padding: 1.5rem 2.5rem;
    display: inline-block;
    font-weight: bold;
    letter-spacing: 0.05em;
    text-transform: uppercase;

    transition-property: color, background-color;
    transition-duration: 0.2s;
    transition-timing-function: ease-in-out;

    &:hover {
        background-color: ${GREY_100};
        color: ${PRIMARY_700};
    }
`;

const PageHeader = styled.h1`
    ${PRIMARY_BOLD_36}
`;
const SectionHeader = styled.h2`
    ${PRIMARY_BOLD_30}
`;
const SectionSubHeader = styled.h3`
    ${PRIMARY_BOLD_24}
`;
const Paragraph = styled.p`
    ${SECONDARY_18}
    max-width: 35em;
`;

function AboutPage() {
    return (
        <div>
            <PageHeader>About</PageHeader>
            <SectionHeader>Warfare Rules Manager</SectionHeader>
            <Paragraph>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Modi
                vel, iure fugit, quidem provident, suscipit totam molestiae nisi
                itaque porro facilis odit illum! Sit necessitatibus, non natus
                accusamus labore deleniti? Lorem ipsum, dolor sit amet
                consectetur adipisicing elit. Modi vel, iure fugit, quidem
                provident, suscipit totam molestiae nisi itaque porro facilis
                odit illum! Sit necessitatibus, non natus accusamus labore
                deleniti? Lorem ipsum, dolor sit amet consectetur adipisicing
                elit. Modi vel, iure fugit, quidem provident, suscipit totam
                molestiae nisi itaque porro facilis odit illum! Sit
                necessitatibus, non natus accusamus labore deleniti?
            </Paragraph>
            <SectionHeader>Licences</SectionHeader>
            <SectionSubHeader>Warfare Rules Manager</SectionSubHeader>
            <Paragraph>
                The source code for this application is available at GitHub
                under the MIT license.
            </Paragraph>
            <SectionSubHeader>Strongholds and Followers</SectionSubHeader>
            <Paragraph>
                This application includes Open Game Content from Strongholds and
                Followers © 2018 MCDM Productions, LLC. It is used here under
                the terms of the <Link to="/ogl10a">Open Game License</Link>
            </Paragraph>
        </div>
    );
}

function LicensePage() {
    return (
        <div>
            <PageHeader>OPEN GAME LICENSE Version 1.0a</PageHeader>
            <Paragraph>
                The following text is the property of Wizards of the Coast, Inc.
                and is Copyright 2000 Wizards of the Coast, Inc (“Wizards”). All
                Rights Reserved.
            </Paragraph>
            <Paragraph>
                1 Definitions: (a) “Contributors” means the copyright and/or
                trademark owners who have contributed Open Game Content; (b)
                “Derivative Material” means copyrighted material including
                derivative works and translations (including into other computer
                languages), potation, modification, correction, addition,
                extension, upgrade, improvement, compilation, abridgment or
                other form in which an existing work may be recast, transformed
                or adapted; (c) “Distribute” means to reproduce, license, rent,
                lease, sell, broadcast, publicly display, transmit or otherwise
                distribute; (d) “Open Game Content” means the game mechanic and
                includes the methods, procedures, processes and routines to the
                extent such content does not embody the Product Identity and is
                an enhancement over the prior art and any additional content
                clearly identified as Open Game Content by the Contributor, and
                means any work covered by this License, including translations
                and derivative works under copyright law, but specifically
                excludes Product Identity. (e) “Product Identity” means product
                and product line names, logos and identifying marks including
                trade dress; artifacts; creatures characters; stories,
                storylines, plots, thematic elements, dialogue, incidents,
                language, artwork, symbols, designs, depictions, likenesses,
                formats, poses, concepts, themes and graphic, photographic and
                other visual or audio representations; names and descriptions of
                characters, spells, enchantments, personalities, teams,
                personas, likenesses and special abilities; places, locations,
                environments, creatures, equipment, magical or supernatural
                abilities or effects, logos, symbols, or graphic designs; and
                any other trademark or registered trademark clearly identified
                as Product identity by the owner of the Product Identity, and
                which specifically excludes the Open Game Content; (f)
                “Trademark” means the logos, names, mark, sign, motto, designs
                that are used by a Contributor to identify itself or its
                products or the associated products contributed to the Open Game
                License by the Contributor (g) “Use”, “Used” or “Using” means to
                use, Distribute, copy, edit, format, modify, translate and
                otherwise create Derivative Material of Open Game Content. (h)
                “You” or “Your” means the licensee in terms of this agreement.
            </Paragraph>
            <Paragraph>
                2. The License: This License applies to any Open Game Content
                that contains a notice indicating that the Open Game Content may
                only be Used under and in terms of this License. You must affix
                such a notice to any Open Game Content that you Use. No terms
                may be added to or subtracted from this License except as
                described by the License itself. No other terms or conditions
                may be applied to any Open Game Content distributed using this
                License.
            </Paragraph>
            <Paragraph>
                3. Offer and Acceptance: By Using the Open Game Content You
                indicate Your acceptance of the terms of this License.
            </Paragraph>
            <Paragraph>
                4. Grant and Consideration: In consideration for agreeing to use
                this License, the Contributors grant You a perpetual, worldwide,
                royalty-free, non-exclusive license with the exact terms of this
                License to Use, the Open Game Content.
            </Paragraph>
            <Paragraph>
                5. Representation of Authority to Contribute: If You are
                contributing original material as Open Game Content, You
                represent that Your Contributions are Your original creation
                and/or You have sufficient rights to grant the rights conveyed
                by this License.
            </Paragraph>
            <Paragraph>
                6. Notice of License Copyright: You must update the COPYRIGHT
                NOTICE portion of this License to include the exact text of the
                COPYRIGHT NOTICE of any Open Game Content You are copying,
                modifying or distributing, and You must add the title, the
                copyright date, and the copyright holder’s name to the COPYRIGHT
                NOTICE of any original Open Game Content you Distribute.
            </Paragraph>
            <Paragraph>
                7. Use of Product Identity: You agree not to Use any Product
                Identity, including as an indication as to compatibility, except
                as expressly licensed in another, independent Agreement with the
                owner of each element of that Product Identity. You agree not to
                indicate compatibility or co-adaptability with any Trademark or
                Registered Trademark in conjunction with a work containing Open
                Game Content except as expressly licensed in another,
                independent Agreement with the owner of such Trademark or
                Registered Trademark. The use of any Product Identity in Open
                Game Content does not constitute a challenge to the ownership of
                that Product Identity. The owner of any Product Identity used in
                Open Game Content shall retain all rights, title and interest in
                and to that Product Identity.
            </Paragraph>
            <Paragraph>
                8. Identification: If you distribute Open Game Content You must
                clearly indicate which portions of the work that you are
                distributing are Open Game Content.
            </Paragraph>
            <Paragraph>
                9. Updating the License: Wizards or its designated Agents may
                publish updated versions of this License. You may use any
                authorized version of this License to copy, modify and
                distribute any Open Game Content originally distributed under
                any version of this License.
            </Paragraph>
            <Paragraph>
                10. Copy of this License: You MUST include a copy of this
                License with every copy of the Open Game Content You Distribute.
            </Paragraph>
            <Paragraph>
                11. Use of Contributor Credits: You may not market or advertise
                the Open Game Content using the name of any Contributor unless
                You have written permission from the Contributor to do so.
            </Paragraph>
            <Paragraph>
                12. Inability to Comply: If it is impossible for You to comply
                with any of the terms of this License with respect to some or
                all of the Open Game Content due to statute, judicial order, or
                governmental regulation then You may not Use any Open Game
                Material so affected.
            </Paragraph>
            <Paragraph>
                13. Termination: This License will terminate automatically if
                You fail to comply with all terms herein and fail to cure such
                breach within 30 days of becoming aware of the breach. All
                sublicenses shall survive the termination of this License.
            </Paragraph>
            <Paragraph>
                14. Reformation: If any provision of this License is held to be
                unenforceable, such provision shall be reformed only to the
                extent necessary to make it enforceable.
            </Paragraph>
            <Paragraph>
                15. COPYRIGHT NOTICE
                <br />
                Open Game License v 1.0a Copyright 2000, Wizards of the Coast,
                Inc.
                <br />
                System Reference Document Copyright 2000-2003, Wizards of the
                Coast, Inc.; Authors Jonathan Tweet, Monte Cook, Skip Williams,
                Rich Baker, Andy Collins, David Noonan, Rich Redman, Bruce R.
                Cordell, John D. Rateliff, Thomas Reid, James Wyatt, based on
                original material by E. Gary Gygax and Dave Arneson.
                <br />
                System Reference Document 5.0 Copyright 2016, Wizards of the
                Coast, Inc.; Authors Mike Mearls, Jeremy Crawford, Chris
                Perkins, Rodney Thompson, Peter Lee, James Wyatt, Robert J.
                Schwalb, Bruce R. Cordell, Chris Sims, and Steve Townshend,
                based on original material by E. Gary Gygax and Dave Arneson.
                <br />
                The Markdown SRD5 Copyright 2016, Garrett Guillotte.
                <br />
                Strongholds and Followers Copyright 2018, MCDM Productions, LLC.
            </Paragraph>
            <Paragraph>END OF LICENSE</Paragraph>
        </div>
    );
}

const ArmyLink = styled.a`
    padding: 0.5rem 1rem;
    margin: 0.5rem 0;
    display: block;
    cursor: pointer;
    border-left: 4px solid transparent;

    &:hover {
        background-color: ${GREY_100};
    }

    ${props =>
        props.active &&
        css`
            border-left: 4px solid ${PRIMARY_500};
        `}
`;

function ArmiesPage() {
    return (
        <div
            css={css`
                display: flex;
            `}
        >
            <aside
                css={css`
                    flex: 0 0 300px;
                    margin-right: 2rem;
                `}
            >
                <ArmyLink active>Example Army 1</ArmyLink>
                <ArmyLink>Example Army 2</ArmyLink>
                <ArmyLink>Example Army 3</ArmyLink>
                <ArmyLink>Example Army 4</ArmyLink>
                <div>
                    <button>Add New</button>
                </div>
            </aside>
            <main
                css={css`
                    flex: 1 0 0px;
                    padding: 1rem;
                `}
            >
                <div>Main</div>
            </main>
        </div>
    );
}

function HomePage() {
    return <div>Home</div>;
}

function DataPage() {
    return (
        <div
            css={css`
                display: flex;
            `}
        >
            <aside
                css={css`
                    flex: 0 0 300px;
                    margin-right: 2rem;
                `}
            >
                <ArmyLink active>Ancestry</ArmyLink>
            </aside>
            <main
                css={css`
                    flex: 1 0 0px;
                `}
            >
                <div
                    css={css`
                        background-color: white;
                        box-shadow: 0px 1px 5px ${GREY_200};
                        padding: 2rem;
                        margin-bottom: 1.5rem;
                    `}
                >
                    <h1>Default Ancestries</h1>
                    <table css={dataTableStyles}>
                        <thead>
                            <tr>
                                <th css={leftAlignStyles}>Name</th>
                                <th css={rightAlignStyles}>Attack</th>
                                <th css={rightAlignStyles}>Power</th>
                                <th css={rightAlignStyles}>Defense</th>
                                <th css={rightAlignStyles}>Toughness</th>
                                <th css={rightAlignStyles}>Morale</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ancestryIds
                                .map(id => ancestries[id])
                                .map(ancestry => (
                                    <tr>
                                        <td css={leftAlignStyles}>
                                            {ancestry.name}
                                        </td>
                                        <td css={rightAlignStyles}>
                                            {ancestry.attack}
                                        </td>
                                        <td css={rightAlignStyles}>
                                            {ancestry.power}
                                        </td>
                                        <td css={rightAlignStyles}>
                                            {ancestry.defense}
                                        </td>
                                        <td css={rightAlignStyles}>
                                            {ancestry.toughness}
                                        </td>
                                        <td css={rightAlignStyles}>
                                            {ancestry.morale}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>

                <div
                    css={css`
                        background-color: white;
                        box-shadow: 0px 1px 5px ${GREY_200};
                        padding: 2rem;
                    `}
                >
                    <div
                        css={css`
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                        `}
                    >
                        <h1>Custom Ancestries</h1>
                        <button
                            css={css`
                                appearance: none;
                                border: none;
                                padding: 0.5rem 0.75rem;
                                margin: 0;
                                background: none;
                                color: ${PRIMARY_600};
                                font-weight: bold;
                                border-radius: 6px;
                                border: 2px solid ${PRIMARY_600};
                                outline: none;

                                transition-property: color, background-color,
                                    border;
                                transition-duration: 0.2s;
                                transition-timing-function: ease-in-out;

                                &:focus {
                                    outline: 2px solid ${YELLOW_500};
                                }
                            `}
                        >
                            Create New
                        </button>
                    </div>
                    <table css={dataTableStyles}>
                        <thead>
                            <tr>
                                <th css={leftAlignStyles}>Name</th>
                                <th css={rightAlignStyles}>Attack</th>
                                <th css={rightAlignStyles}>Power</th>
                                <th css={rightAlignStyles}>Defense</th>
                                <th css={rightAlignStyles}>Toughness</th>
                                <th css={rightAlignStyles}>Morale</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ancestryIds
                                .slice(4, 9)
                                .map(id => ancestries[id])
                                .map(ancestry => (
                                    <tr>
                                        <td css={leftAlignStyles}>
                                            {ancestry.name}
                                        </td>
                                        <td css={rightAlignStyles}>
                                            {ancestry.attack}
                                        </td>
                                        <td css={rightAlignStyles}>
                                            {ancestry.power}
                                        </td>
                                        <td css={rightAlignStyles}>
                                            {ancestry.defense}
                                        </td>
                                        <td css={rightAlignStyles}>
                                            {ancestry.toughness}
                                        </td>
                                        <td css={rightAlignStyles}>
                                            {ancestry.morale}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </main>
        </div>
    );
}

const dataTableStyles = css`
    width: 100%;
    border-spacing: 0;
`;
const leftAlignStyles = css`
    text-align: left;
    padding: 0.5rem 1rem;

    th&,
    tr:nth-child(2n) td& {
        background-color: ${GREY_000};
    }
`;
const rightAlignStyles = css`
    text-align: right;
    padding: 0.5rem 1rem;

    th&,
    tr:nth-child(2n) td& {
        background-color: ${GREY_000};
    }
`;

function App() {
    // return <Army army={army} />;

    return (
        <div>
            <Header />
            <div
                css={css`
                    max-width: 1280px;
                    margin-left: auto;
                    margin-right: auto;
                    padding: 1.5rem 2.5rem;
                `}
            >
                <Router>
                    <HomePage path="/" />
                    <ArmiesPage path="/armies" />
                    <DataPage path="/data" />
                    <AboutPage path="/about" />
                    <LicensePage path="/ogl10a" />
                </Router>
            </div>
        </div>
    );
}

export default App;
